import { ReactElement } from 'react';
import { Grid } from '@material-ui/core';
import EditIcon from '@mui/icons-material/Edit';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { ReactComponent as PauseIcon } from '../icons/PauseIcon.svg';

import Button from '~/ui/components/common/Button';
import { isoToFormat } from '~/utils/date';
import { PatientMonitoringPauseStatus } from '~/services/api/enums';
import { Timezone } from '~/types';

import styles from './PauseMonitoringBanner.module.scss';
import { IPatientMonitoringPauseDto } from '~/services/api/patientMonitoringPauses/types';

interface IProps {
  pause: IPatientMonitoringPauseDto;
  timezone: Timezone;
  onEdit: () => void;
}

const PauseMonitoringBanner = ({ pause, timezone, onEdit }: IProps): ReactElement => {
  const isPlanned = pause.statusId === PatientMonitoringPauseStatus.Planned;

  return (
    <div
      className={`${styles.banner} ${isPlanned ? styles.bannerPlanned : styles.bannerInProgress}`}
    >
      <Grid container spacing={2} alignItems="center" justifyContent="space-between">
        <Grid item xs>
          <Grid container spacing={2} alignItems="center" wrap="nowrap" className={styles.content}>
            <Grid item className={styles.icon}>
              {isPlanned ? (
                <InfoOutlinedIcon className={styles.iconPlanned} />
              ) : (
                <PauseIcon className={styles.iconInProgress} />
              )}
            </Grid>
            <Grid item xs className={styles.text}>
              {isPlanned
                ? 'Monitoring is going to be paused due to '
                : 'Monitoring is currently paused due to '}
              <strong>{pause.reason}</strong> from{' '}
              <strong>{`${isoToFormat(pause.startDate, 'dd MMM yyyy')} ${timezone}`}</strong> to{' '}
              <strong>{`${isoToFormat(pause.endDate, 'dd MMM yyyy')} ${timezone}`}</strong>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Button
            variant="outlined"
            color="default"
            startIcon={<EditIcon />}
            className={`${styles.editBtn} ${
              isPlanned ? styles.editBtnPlanned : styles.editBtnInProgress
            }`}
            onClick={onEdit}
          >
            Edit
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

export default PauseMonitoringBanner;
